module.exports = __webpack_public_path__ + "img/dk.14de9cd5.svg";